// extracted by mini-css-extract-plugin
export default {"container":"FileDocument_container__YqEIY"};